interface DeriveRecordingNameInput {
  // Resolved asset/indication labels, or null when the taxonomy can't resolve
  // the id (e.g. AWS-sourced history rows whose taxonomy is no longer loaded).
  assetLabel: string | null
  indicationLabel: string | null
  isTextNote: boolean
  noteBody?: string | null
}

/**
 * Build a human-readable title for a submission/draft. Prefers the resolved
 * "Asset - Indication" labels; when neither resolves it falls back to something
 * meaningful (the note's first line for text, "Audio note" otherwise) so a raw
 * taxonomy id like `ast_UA_… - ind_st7D…` is never shown.
 */
export function deriveRecordingName(input: DeriveRecordingNameInput): string {
  const parts = [input.assetLabel, input.indicationLabel].filter(
    (part): part is string => Boolean(part),
  )
  if (parts.length > 0) {
    return parts.join(' - ')
  }

  if (input.isTextNote) {
    const firstLine = (input.noteBody ?? '').split('\n')[0]?.trim() ?? ''
    return firstLine || 'Text note'
  }
  return 'Audio note'
}
